<template>
  <div v-show="showGraph" id="container"></div>
</template>
<script>
import { Graph } from '@antv/x6'
import { Snapline } from '@antv/x6-plugin-snapline'
export default {
  name: 'GraphView',
  methods: {
    closeGraph() {
      debugger
      this.showGraph = !this.showGraph
    }
  },
  mounted() {
    const graph = new Graph({
      container: document.getElementById('container'),
      autoResize: true,
      panning: true,
      mousewheel: {
        enabled: true,
        modifiers: 'ctrl'
      },
      background: {
        color: '#F2F7FA'
      },
      interacting: {
        nodeMovable: false // 全局禁止节点移动
      },
      grid: {
        visible: true,
        type: 'doubleMesh',
        args: [
          {
            color: '#eee', // 主网格线颜色
            thickness: 1 // 主网格线宽度
          },
          {
            color: '#ddd', // 次网格线颜色
            thickness: 1, // 次网格线宽度
            factor: 5 // 主次网格线间隔
          }
        ]
      }
    })
    // graph.fromJSON(this.data) // 渲染元素
    graph.centerContent() // 居中显示
    graph.use(
      new Snapline({
        enabled: true
      })
    )
    Graph.registerNode(
      'custom-node',
      {
        inherit: 'rect', // 继承于 rect 节点
        width: 100,
        height: 40,
        markup: [
          {
            tagName: 'rect', // 标签名称
            selector: 'body' // 选择器
          },
          {
            tagName: 'image',
            selector: 'img'
          },
          {
            tagName: 'text',
            selector: 'label'
          }
        ],
        attrs: {
          body: {
            stroke: '#8f8f8f',
            strokeWidth: 1,
            fill: '#fff',
            rx: 6,
            ry: 6
          },
          img: {
            'xlink:href': 'https://gw.alipayobjects.com/zos/antfincdn/FLrTNDvlna/antv.png',
            width: 16,
            height: 16,
            x: 12,
            y: 12
          }
        }
      },
      true
    )
    const source = graph.addNode({
      shape: 'custom-node', // 可以直接使用上面注册过的 shape
      x: 40,
      y: 40,
      label: 'hello'
    })
    const source2 = graph.addNode({
      shape: 'custom-node', // 可以直接使用上面注册过的 shape
      x: 200,
      y: 40,
      label: 'hello'
    })
    graph.addNode({
      shape: 'circle', // 可以直接使用上面注册过的 shape
      x: 250,
      y: 100,
      width: 40,
      height: 40,
      label: 'circle'
    })
    // graph.addNode({
    //   shape: 'rect',
    //   x: 40,
    //   y: 40,
    //   width: 80,
    //   height: 40,
    //   label: 'rect',
    //   attrs: this.commonAttrs
    // })

    // graph.addNode({
    //   shape: 'circle',
    //   x: 180,
    //   y: 40,
    //   width: 40,
    //   height: 40,
    //   label: 'circle',
    //   attrs: this.commonAttrs
    // })

    // graph.addNode({
    //   shape: 'ellipse',
    //   x: 280,
    //   y: 40,
    //   width: 80,
    //   height: 40,
    //   label: 'ellipse',
    //   attrs: this.commonAttrs
    // })

    // graph.addNode({
    //   shape: 'path',
    //   x: 420,
    //   y: 40,
    //   width: 40,
    //   height: 40,
    //   // https://www.svgrepo.com/svg/13653/like
    //   path: 'M24.85,10.126c2.018-4.783,6.628-8.125,11.99-8.125c7.223,0,12.425,6.179,13.079,13.543c0,0,0.353,1.828-0.424,5.119c-1.058,4.482-3.545,8.464-6.898,11.503L24.85,48L7.402,32.165c-3.353-3.038-5.84-7.021-6.898-11.503c-0.777-3.291-0.424-5.119-0.424-5.119C0.734,8.179,5.936,2,13.159,2C18.522,2,22.832,5.343,24.85,10.126z',
    //   attrs: this.commonAttrs,
    //   label: 'path'
    // })

    // graph.addNode({
    //   shape: 'polygon',
    //   x: 60,
    //   y: 150,
    //   width: 40,
    //   height: 40,
    //   points: '100,10 40,198 190,78 10,78 160,198',
    //   attrs: this.commonAttrs,
    //   label: 'polygon'
    // })

    // graph.addNode({
    //   shape: 'polyline',
    //   x: 180,
    //   y: 150,
    //   width: 40,
    //   height: 40,
    //   label: 'polyline',
    //   attrs: {
    //     body: {
    //       ...this.commonAttrs.body,
    //       refPoints: '0,0 0,10 10,10 10,0'
    //     },
    //     label: this.commonAttrs.label
    //   }
    // })

    // graph.addNode({
    //   shape: 'image',
    //   x: 290,
    //   y: 150,
    //   width: 60,
    //   height: 40,
    //   imageUrl: 'https://gw.alipayobjects.com/os/s/prod/antv/assets/image/logo-with-text-73b8a.svg',
    //   label: 'image',
    //   attrs: this.commonAttrs
    // })
  },
  created() {
    // this.$request('/v1/forecast?latitude=39.9042&longitude=116.4074&hourly=temperature_2m').then(
    //   async (res) => {
    //     console.log(res)
    //   }
    // )
  },
  data() {
    return {
      showGraph: true,
      data: {
        nodes: [
          {
            id: 'node1',
            shape: 'rect',
            x: 40,
            y: 40,
            width: 100,
            height: 40,
            label: 'hello',
            attrs: {
              // body 是选择器名称，选中的是 rect 元素
              body: {
                stroke: '#8f8f8f',
                strokeWidth: 1,
                fill: '#fff',
                rx: 6,
                ry: 6
              }
            }
          },
          {
            id: 'node2',
            shape: 'rect',
            x: 160,
            y: 180,
            width: 100,
            height: 40,
            label: 'world',
            attrs: {
              body: {
                stroke: '#8f8f8f',
                strokeWidth: 1,
                fill: '#fff',
                rx: 6,
                ry: 6
              }
            }
          }
        ],
        edges: [
          {
            shape: 'edge',
            source: 'node1',
            target: 'node2',
            label: 'x6',
            attrs: {
              // line 是选择器名称，选中的边的 path 元素
              line: {
                stroke: '#8f8f8f',
                strokeWidth: 1
              }
            }
          }
        ],
        commonAttrs: {
          body: {
            fill: '#fff',
            stroke: '#8f8f8f',
            strokeWidth: 1
          },
          label: {
            refX: 0.5,
            refY: '100%',
            refY2: 4,
            textAnchor: 'middle',
            textVerticalAnchor: 'top'
          }
        }
      }
    }
  }
}
</script>
<style scoped lang="less">
#container {
  width: 100%;
  height: 100vh;
}
</style>
